export const hmsToSeconds = (duration: string) => {
    const p = duration.split(':');
    let s = 0, m = 1;

    while (p.length > 0) {
        s += m * parseInt(<string>p.pop(), 10);
        m *= 60;
    }
    return s;
}

export const secondsToHms = (duration: number) => {
    return new Date(duration * 1000).toISOString().substring(11, 19);
}

export const formatDuration = (duration: string) => {
    return secondsToHms(hmsToSeconds(duration));
}